/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_Row_2Inputs */

const en_svc_n8n_art_row_2 = /** @type {(inputs: Svc_N8n_Art_Row_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order with no delivery address`)
};

const lv_svc_n8n_art_row_2 = /** @type {(inputs: Svc_N8n_Art_Row_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījums bez piegādes adreses`)
};

/**
* | output |
* | --- |
* | "Order with no delivery address" |
*
* @param {Svc_N8n_Art_Row_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_row_2 = /** @type {((inputs?: Svc_N8n_Art_Row_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_Row_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_row_2(inputs)
	return en_svc_n8n_art_row_2(inputs)
});